import { useSelector } from 'react-redux'
import { useTabNavigation } from 'src/redux/slices/navigation/hooks'
import { hasActiveProject } from 'src/redux/slices/project/selectors'

import NoProjectWidget from '../components/NoProjectWidget'
import Tasks from '../components/Tasks'

const TasksPage: React.FC = () => {
  useTabNavigation()
  const active = useSelector(hasActiveProject)
  return active ? <Tasks /> : <NoProjectWidget />
}
export default TasksPage
